import React, {Component} from 'react'
import Included from '../Included'
import { Link } from 'react-router'
import commonUI from '../../../js/commonUI'
class BuildDetail extends Component {

  constructor(props) {
    super(props)
    this.state = {
      error: null
    };
  }

  handleBuildError(e) {
    this.setState({error: e});
  }

  handleSubmit(e) {
    var self = this;
    e.preventDefault();

    let data = {};
    let loader = commonUI.initializeLoader({message: 'Building Resources...'});

    for (let i = 0; i < e.target.length; i++) {
      if(e.target[i].type === 'checkbox') {
        data[e.target[i].name.toLowerCase()] = e.target[i].checked;
      }
    }

    $.ajax({
      type: 'POST',
      url: 'custom-build',
      data: JSON.stringify(data),
      contentType: "application/json; charset=utf-8",
      success: (e) => {
        loader.destroy();
        self.handleBuildError(null);
        $.fileDownload(e);
      },
      error: (e) => {
        loader.destroy();
        self.handleBuildError(e.responseText);
      }
    });
  }

  renderErrorMessage() {
    if (this.state.error){
      return(
        <div className="alert alert--error" role="alert">
          <code>{this.state.error}</code>
        </div>);
    }
  }

  render() {
    const { components, onIncludeClick } = this.props
    return (
      <section>
        <a className="anchor" id="build"></a>
        <br/>
        <h2>Create a custom package</h2>
        <p>
          Core components are always included. Optional components consist of more specific use cases that your project may not require out of the box.<br/>
        Select your components and click the 'Package' button to generate and download a customised set of assets.
        </p>

        <form onSubmit={this.handleSubmit.bind(this)}>
          <table className="table table--fixed table--cells table--comfy">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Included</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Core Components</td><td className="text--center">Included</td></tr>
              {components.Components.map((object, index) => {
                return (
                  <tr key={object.template}>
                    <td><Link to={`components${object.anchor}`}>{object.name}</Link></td>
                    <td className="text--center">
                      <input type="checkbox" name={object.template} checked={object.include} onChange={ () => onIncludeClick('Components', index)}/>
                      <label className="hide">{object.name}</label>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
            <br/>
            {this.renderErrorMessage()}
            <br/>
            <button type="submit" className="btn btn--positive">Package
              <i className="fa fa-magic"></i>
            </button>
            <br/><br/>
        </form>
        <hr/>
      </section>
    )
  }
}

export default BuildDetail



// WEBPACK FOOTER //
// ./styleguide/components/sections/BuildDetail.js